<template>
  <div class="pageContainer">

    <div class="asideContainer" style="border-right: 8px solid whitesmoke;">
      <div class="size">
        <div class="title">{{'组立概况'}}</div>
        <div style="width: 600px;height: 220px" >
          <el-row style="margin-top: 30px;margin-left: 60px">
            <div class="box" style="background-color:rgb(93, 201, 131)">
              <div>{{'在岗工人'}}</div>
              <h2 style="font-size: 20px">{{formData.workerCnt}}</h2></div>
            <div class="box" style="background-color:dodgerblue;">
              <div>{{'开工产线'}}</div>
              <h2 style="font-size: 20px">{{formData.lineCnt}}</h2>
            </div>
            <div class="box" style="background-color:royalblue;">
              <div>{{'开工物件'}}</div>
              <h2 style="font-size: 20px">{{formData.wujianCnt}}</h2></div>
          </el-row>
          <el-row style="margin-top: 15px;margin-left: 130px">
            <div class="box" style="background-color:rgb(217, 154, 79);">
              <div>{{'完工数量'}}</div>
              <h2 style="font-size: 20px">{{formData.completedCnt}}</h2></div>
            <div class="box" style="background-color:rgb(212, 109, 72);">
              <div>{{'生产中'}}</div>
              <h2 style="font-size: 20px">{{formData.inProduceCnt}}</h2></div>
          </el-row>
        </div>

      </div>

      <div class="size">
        <div class="title">{{'组立产量-物件别'}}
          <el-select v-model="wuJianId" @change="getTotalOutput" clearable placeholder="物件名称" size="small" class="wujian_select_size">
            <el-option
                v-for="item in wuJianNames"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="chart_size" v-loading="totalOutputLoading" element-loading-text="数据加载中" style="width: 550px;height: 250px" id="totalOutput"/>
      </div>


      <div class="size">
        <div class="title">{{'组立生产性-物件别'}}
          <el-date-picker v-model="productiveDate.year" @change="getProductiveOutput" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>

          <el-select v-model="productiveDate.productiveWuJianId" @change="getProductiveOutput" clearable placeholder="物件名称" size="small" class="wujian_select_size">
            <el-option
                v-for="item in wuJianNames"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="chart_size" v-loading="productiveOutputLoading" element-loading-text="数据加载中" style="width: 550px;height: 250px" id="productiveOutput"/>
      </div>

      <div class="size">
        <div class="title">{{'滞留推移-物件别'}}
          <el-select v-model="stayWuJianId" @change="getStay" clearable placeholder="物件名称" size="small" class="wujian_select_size">
            <el-option
                v-for="item in wuJianNames"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="chart_size" v-loading="stayLoading" element-loading-text="数据加载中" style="width: 550px;height: 250px" id="stay"/>
      </div>

    </div>
    <div class="asideContainer" style="border-right: 8px solid whitesmoke;">

      <div class="size">
        <div class="title">{{'物件进度'}}
          <el-select v-model="scheduleWuJianId" @change="getSchedule" clearable placeholder="物件名称" size="small" class="wujian_select_size">
            <el-option
                v-for="item in wuJianNames"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="chart_size" v-loading="scheduleLoading" element-loading-text="数据加载中" style="width: 550px;height: 220px" id="schedule"/>

      </div>

      <div class="size">
        <div class="title">{{'产线日产量'}}
          <el-select v-model="lineDayId" @change="getLineDayOutput" clearable placeholder="产线" size="small" class="line_select_size">
            <el-option
                v-for="item in lineNames"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-date-picker v-model="lineDay.day" @change="getLineDayOutput" format="YYYY 年 M 月" value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 130px" size="small"/>
        </div>
        <div class="chart_size" v-loading="lineDayOutputLoading" element-loading-text="数据加载中" style="width: 550px;height: 250px" id="lineDayOutput"/>
      </div>

      <div class="size">
        <div class="title">{{'物件日生产性'}}
          <el-select v-model="productiveDay.wuJianId" @change="getDayProductiveOutput" clearable placeholder="物件名称" size="small" class="wujian_select_size">
            <el-option
                v-for="item in wuJianNames"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-date-picker v-model="productiveDay.day" @change="getDayProductiveOutput" format="YYYY 年 M 月" value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 130px" size="small"/>

        </div>
        <div class="chart_size" v-loading="dayProductiveOutputLoading" element-loading-text="数据加载中" style="width: 550px;height: 250px" id="dayProductiveOutput"/>
      </div>

      <div class="size"/>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "AmHomePage",
  data() {
    return {
      scanDetailsDialog:false,
      scanRecord:[],
      productiveDate:{
        year:this.$common.getCurrentYearByMonth().toString(),
        productiveWuJianId: '',
      },
      lineDay: {
        day: this.getDateFormat(),
      },
      productiveDay: {
        day: this.getDateFormat(),
        wuJianId:''
      },
      wuJianId: '',
      wuJianNames: [],
      lineNames: [],
      scheduleWuJianId:'',
      stayWuJianId:'',
      lineDayId: '',
      formData: {},
      //组立产量
      totalOutput: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {},
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            name: '产量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      totalOutputLoading: false,
      //组立日产量
      lineDayOutput: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {},
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            name: '产量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      lineDayOutputLoading: false,
      //物件进度
      schedule : {
        tooltip: {
          trigger: 'item',
          formatter:  "{b} : {c} ({d}%)"
        },
        legend: {
          top: 0,
          left: 'left',
          data: []
        },
        series: [
          {
            type: 'pie',
            radius: '65%',
            center: ['50%', '50%'],
            selectedMode: 'single',
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
              }
            }
          }
        ]
      },
      scheduleLoading: false,
      //滞留
      stay: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {},
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            name: '滞留',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      stayLoading: false,
      //物件生产性
      productiveOutput: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {},
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            name: '生产性',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      productiveOutputLoading: false,
      //物件日生产性
      dayProductiveOutput: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {},
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            name: '生产性',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      dayProductiveOutputLoading: false,
    }
  },
  methods:{
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)}
    },

    //物件信息
    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('bus/datasource/getWuJianInFo');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
    },
    //产线信息
    async getLineInFo() {
      let {data: res} = await this.$axios.post('am/homePage/getLineInFo');
      if (res.code !== 0) {
        this.$message.error('获取【产线信息】失败')
        return;
      }
      this.lineNames = res.data;
    },
    //物件概况
    async getTotalWuJian() {
      let {data: res} = await this.$axios.post('am/homePage/getTotalWuJian');
      if (res.code !== 0) {
        this.$message.error('获取【物件概况】失败')
        return;
      }
      this.formData = res.data;
    },
    //组立产量-物件别
    async getTotalOutput() {
      let query = {
        wuJianId:this.wuJianId,
      }
      this.totalOutputLoading = true
      let {data: res} = await this.$axios.post('am/homePage/getTotalOutput',query);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.totalOutput.xAxis[0].data = res.data.xAxis
        this.totalOutput.series[0].data = res.data.series
        let a = this.$common.getDivisor(Math.max(...res.data.series))
        this.totalOutput.yAxis[0].max = Math.ceil(Math.max(...res.data.series)/a)*a
        this.totalOutput.yAxis[0].interval = Math.round(this.totalOutput.yAxis[0].max/5*100)/100
      }
      this.renderEcharts('totalOutput',this.totalOutput)

      this.totalOutputLoading = false
    },
    //物件生产性
    async getProductiveOutput() {
      this.productiveOutputLoading = true
      let {data: res} = await this.$axios.post('am/homePage/getProductiveOutput',this.productiveDate);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.productiveOutput.xAxis[0].data = res.data.xAxis
        this.productiveOutput.series[0].data = res.data.series
        let a = this.$common.getDivisor(Math.max(...res.data.series))
        this.productiveOutput.yAxis[0].max = Math.ceil(Math.max(...res.data.series)/a)*a
        this.productiveOutput.yAxis[0].interval = Math.round(this.productiveOutput.yAxis[0].max/5*100)/100
      }
      this.renderEcharts('productiveOutput',this.productiveOutput)

      this.productiveOutputLoading = false
    },

    //滞留推移-物件别
    async getStay() {
      let query = {
        wuJianId:this.stayWuJianId,
      }
      this.stayLoading = true
      let {data: res} = await this.$axios.post('am/homePage/getStay',query);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.stay.xAxis[0].data = res.data.xAxis
        this.stay.series[0].data = res.data.series
        let a = this.$common.getDivisor(Math.max(...res.data.series))
        this.stay.yAxis[0].max = Math.ceil(Math.max(...res.data.series)/a)*a
        this.stay.yAxis[0].interval = Math.round(this.stay.yAxis[0].max/5*100)/100
      }
      this.renderEcharts('stay',this.stay)

      this.stayLoading = false
    },

    //物件进度
    async getSchedule() {
      let query = {
        wuJianId:this.scheduleWuJianId,
      }
      this.scheduleLoading = true
      let {data: res} = await this.$axios.post('am/homePage/getSchedule',query);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.schedule.legend.data = res.data.legend
        this.schedule.series[0].data = res.data.series
      }
      this.renderEcharts('schedule',this.schedule)

      this.scheduleLoading = false
    },

    //产线日产量
    async getLineDayOutput() {
      if (!this.lineDay.day){
        this.lineDay.day = this.getDateFormat()
      }
      this.lineDayOutputLoading = true
      this.lineDay.lineDayId = this.lineDayId
      let {data: res} = await this.$axios.post('am/homePage/getLineDayOutput',this.lineDay);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.lineDayOutput.xAxis[0].data = res.data.xAxis
        this.lineDayOutput.series[0].data = res.data.series
        let a = this.$common.getDivisor(Math.max(...res.data.series))
        this.lineDayOutput.yAxis[0].max = Math.ceil(Math.max(...res.data.series)/a)*a
        this.lineDayOutput.yAxis[0].interval = Math.round(this.lineDayOutput.yAxis[0].max/5*100)/100
      }
      this.renderEcharts('lineDayOutput',this.lineDayOutput)

      this.lineDayOutputLoading = false
    },
    //物件日生产性
    async getDayProductiveOutput() {
      if (!this.productiveDay.day){
        this.lineDay.day = this.getDateFormat()
      }
      this.dayProductiveOutputLoading = true
      let {data: res} = await this.$axios.post('am/homePage/getDayProductiveOutput',this.productiveDay);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.dayProductiveOutput.xAxis[0].data = res.data.xAxis
        this.dayProductiveOutput.series[0].data = res.data.series
        let a = this.$common.getDivisor(Math.max(...res.data.series))
        this.dayProductiveOutput.yAxis[0].max = Math.ceil(Math.max(...res.data.series)/a)*a
        this.dayProductiveOutput.yAxis[0].interval = Math.round(this.dayProductiveOutput.yAxis[0].max/5*100)/100
      }
      this.renderEcharts('dayProductiveOutput',this.dayProductiveOutput)

      this.dayProductiveOutputLoading = false
    },

  },

  mounted() {
    this.getSchedule()
    this.getLineDayOutput()
    this.getProductiveOutput()
    this.getTotalOutput()
    this.getStay()
    this.getDayProductiveOutput()
  },
  created() {
    this.getWuJianInFo()
    this.getLineInFo()
    this.getTotalWuJian()
  },

}
</script>

<style scoped>
.pageContainer{
  display: flex;
  flex-direction: row;
  width: 100%;
}

.asideContainer{
  width: 50%;
  height: 1300px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}
.size{
  width: 100%;
  height: 440px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.title{
  border-left: 3px solid steelblue;
  height: 25px;
  width: 90%;
  font-size: 16px;
  padding-left: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.chart_size{
  width:770px;
  height: 440px
}
.box{
  width: 120px;
  font-size: 20px;
  color: #FFFFFF;
  border-radius: 5px;
  text-align: center;
  margin-left: 25px;
}
.wujian_select_size{
  width: 200px;
  margin-left: 10px;
}
.line_select_size{
  width: 150px;
  margin-left: 10px;
}
.red {
  color: red !important;
}
.green {
  color: green !important;
}

</style>